class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('#search-input');
    this.predictiveSearchResults = document.querySelector('#search-results');
    this.searchType = this.getAttribute('data-search-type') || 'products';

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
  }

  onChange() {
    const searchTerm = encodeURIComponent(this.input.value.trim());

    if (!searchTerm.length) {
      $(this.predictiveSearchResults).fadeOut(function () {
        $('.search__initial').fadeIn();
      });

      return;
    }

    this.getSearchResults(searchTerm);
  }

  async getSearchResults(searchTerm) {
    try {
      const response = await fetch(
        `/search?q=${searchTerm}&type=product,article&options[unavailable_products]=show&options[prefix]=last&view=predictive`,
      );

      if (!response.ok) {
        throw new Error(`Search failed: ${response.status}`);
      }

      const responseText = await response.text();

      if (responseText.indexOf('no-results') != -1) {
        $('.navbar__search').addClass('search-results--no-results');
        return;
      }

      $('.navbar__search').removeClass('search-results--no-results');

      // Parse the HTML response
      const parser = new DOMParser().parseFromString(responseText, 'text/html');
      const searchPredictive = parser.querySelector('.search-predictive');

      if (searchPredictive && this.predictiveSearchResults) {
        // Extract the appropriate section based on search type
        const targetSection = searchPredictive.querySelector(
          this.searchType === 'product'
            ? '#predictive-search-products-results'
            : '#predictive-search-articles-results',
        );

        if (targetSection) {
          this.predictiveSearchResults.innerHTML = targetSection.innerHTML;

          // Update wishlist icons if that function exists globally
          window.updateProductCardsWishlist?.();

          if ($('.search__initial').is(':visible')) {
            $(this.predictiveSearchResults).hide();

            $('.search__initial').fadeOut(() => {
              this.open();
            });
          } else {
            this.open();
          }
        } else {
          console.error(`Missing section for ${this.searchType} in response`);
          this.close();
        }
      } else {
        console.error('Missing .search-predictive element in response');
        this.close();
      }
    } catch (error) {
      console.error('Search error:', error);
      this.close();
    }
  }

  open() {
    $(this.predictiveSearchResults).fadeIn();
  }

  close() {
    $(this.predictiveSearchResults).fadeOut();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
